<template>
  <div>
    <Bar text="费用确认"></Bar>
    <div class="e-flex jc-center">
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        style="width: 600px"
        label-width="140px"
      >
        <el-form-item label="保险额度（万元）" prop="guaranteeAmount">
          <el-input-number
            v-model="form.guaranteeAmount"
            @change="handleCalcAmount"
            :min="0.0001"
            :max="80"
            :step="10"
            label="请输入保险额度（万元）"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="应缴纳保险费(元)">
          <div class="text-red fw-6 fs-md">
            {{ productAmount }}
          </div>
          <div class="text-red" v-if="this.form.exectronic === '1'" style="font-size: 12px;">
            {{ this.tipMsg }}
          </div>
        </el-form-item>
        <!-- <el-form-item label="平台服务费(元)">
          <div class="text-red fw-6 fs-md">
            {{ insuranceAmount }}
          </div>
        </el-form-item>
        <el-form-item label="合计(元)">
          <div class="text-red fw-6 fs-md">
            {{ totalAmount }}
          </div>
        </el-form-item> -->
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="form.remarks" />
        </el-form-item>
        <el-form-item>
          <el-button @click="gopage">上一步</el-button>
          <el-button plain v-if="!$route.query.orderID" @click="saveDraft" :loading="draftSaving">保存</el-button>
          <el-button type="primary" @click="onSubmit">下一步</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>




import { fiterData } from '../../../util/dataForma'
import { calculateInsurance, confirmInsurance } from '../../../api/comm'
import {
  mapMutations,
  mapState,
  INSURANCE,
} from '../../../store/modules/insurance'
import { mapGetters, CONFIG_GETTERS } from '@/store/modules/config'
import { cloneDeep, debounce } from 'lodash'
import bar from '../projectBar/bar'
import { isLogin, showLogin } from '@/shared/user'
import { formatArea } from '@/shared/location'
import { pay } from '@/shared/pay'
import { ORDER_TYPE, saveCurrentDraft, clearCurrentDraft } from '@/shared/guaranteeDraft'
export default {
  data() {
    return {
      form: {},
      productAmount: '',
      insuranceAmount: '',
      totalAmount: '',
      draftSaving: false,
      rules: {
        productAmount: [
          {
            required: true,
            message: '获取金额失败请联系客服',
            trigger: 'change',
          },
        ],
        guaranteeAmount: [
          { required: true, message: '请填写保证金额', trigger: 'change' },
        ],
      },
      tipMsg: ''
    }
  },
  computed: {
    ...mapState({
      formStorage: 'insurance',
    }),
    ...mapGetters({
      isZCMOrigin: CONFIG_GETTERS.IS_ZCM_ORIGIN,
    }),
  },
  beforeMount() {
    // step 切换恢复：从 Vuex insurance 读（父组件 init(data) 在 nextTick 后覆盖为最新值）
    const { formStorage } = this
    this.form = cloneDeep(formStorage || {})
    if (this.form.guaranteeAmount) {
      this.form.guaranteeAmount = Number(this.form.guaranteeAmount)
      this.calcAmount()
    }
  },
  components: {
    Bar: bar,
  },
  methods: {
    ...mapMutations({
      in: INSURANCE.INSURANCE,
      clear: INSURANCE.CLEAR,
    }),
    init(data) {
      this.form = cloneDeep(data || {})
      if (this.form.guaranteeAmount) {
        this.form.guaranteeAmount = Number(this.form.guaranteeAmount)
        this.calcAmount()
      }
    },
    calcAmount() {
      calculateInsurance({
        productType: '7000',
        guaranteeAmount: Number((this.form.guaranteeAmount * 10000).toFixed(0)),
        apiId: '',
        province: this.form.province,
        city: this.form.city,
        district: this.form.district,
        outerOrderNo: this.$route.query.outerOrderNo,
        orderId: this.$route.query.orderID,
        projectSource: this.form.projectSource,
        sourceRadio: this.form.sourceRadio
      }).then((res) => {
        this.productAmount = res.data.productPrice.toFixed(2)
        this.insuranceAmount = res.data.servicePrice.toFixed(2)
        this.totalAmount = res.data.totalAmount

        this.form.productAmount = res.data.productPrice
        this.form.insuranceAmount = res.data.servicePrice
        this.form.totalAmount = this.form.productAmount + this.form.insuranceAmount
        const partnerList = this.form.partnerList || []
        const issueInvoiceTip = partnerList.find(item => item.id === this.form.partnerId)?.issueInvoiceTip || ''
        this.tipMsg = issueInvoiceTip
      })
    },
    handleCalcAmount: debounce(function () {
      this.calcAmount()
    }, 200),

    gopage() {
      this.in(this.form)
      this.$emit('changeIndex', 1)
    },
    async saveDraft() {
      this.draftSaving = true
      try {
        await saveCurrentDraft(this, ORDER_TYPE.INSURANCE_7000, 2, this.form)
      } finally {
        this.draftSaving = false
      }
    },
    goPay() {
      const { orderId } = this.form
      if (this.form.payee != undefined) {
        if (this.form.payee=== '2') {
          //线下支付
          // 线下支付
          this.$router.push({
            path: '/wire-transfer',
            query: {
              order: orderId,
            },
          })
        } else {
          // 线上支付
          pay.call(this, orderId)
        }
      } else {
        pay.call(this, orderId)
      }
    },
    onSubmit() {
      if (!isLogin()) {
        showLogin()
        return false
      }
      this.form.rojectAreaName = formatArea(this.form.rojectArea)
      const { province, district, city,payee } = this.form
      this.form.exectronicView = this.form.exectronic === '0'?'纸质-保险投标保函':'电子-保险投标保函'
      this.form.mailPaperGuaranteeView = this.form.mailPaperGuarantee === '0'?'是':'否'
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const form = cloneDeep(this.form)
        this.form.orderType = '7000'
        await fiterData(form)

        this.$showAffirm(form, this.form.exectronic === '0'?'7000':'7000_dz').then(() => {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
          })
          if (this.isZCMOrigin) {
            this.form.apiId = 'zcm'
            this.form.apiAccessConfigId = 8
          }
          confirmInsurance(this.form).then((res) => {
            loading.close()
            if (res.code === 200) {
              this.form.orderId = res.data.orderId
              this.clear()
              // 提交成功，清空 Redis 草稿
              clearCurrentDraft(this, ORDER_TYPE.INSURANCE_7000)
              if (form.exectronic === '1') {
                this.goPay()
              }else{
                let data = {
                  pdfID: res.data.insurancePdfFileId,
                  province: province,
                  district: district,
                  city: city,
                  orderId: res.data.orderId,
                  isNeedCommitment: false
                }

                this.$router.push({
                  name: 'insuranceLetterCmmmit',
                  query: {
                    ...data,
                  },
                })
              }


            }
          }).catch(() => {
              loading.close()
            })

        })
      })
    },
  },
}
</script>